import React from 'react';

const TIERS    = ['all', 'high', 'medium', 'stretch'];
const STATUSES = ['all', 'To Apply', 'Applied', 'Interview', 'Offer', 'Rejected'];

export default function JobFilter({
  accent, filterTier, filterStatus, searchQ,
  onTier, onStatus, onSearch,
}) {
  return (
    <div style={styles.wrap} className="fade-up-3">
      {/* Tier filters */}
      <div style={styles.group}>
        {TIERS.map(t => (
          <button
            key={t}
            onClick={() => onTier(t)}
            style={{
              ...styles.pill,
              borderColor: filterTier === t ? accent : '#1a1e35',
              background:  filterTier === t ? accent + '18' : '#0d0f1c',
              color:       filterTier === t ? accent : '#4a5a78',
            }}
          >
            {t === 'all' ? 'All Tiers' : t.charAt(0).toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      {/* Status filter */}
      <div style={styles.group}>
        <select
          value={filterStatus}
          onChange={e => onStatus(e.target.value)}
          style={styles.select}
        >
          {STATUSES.map(s => (
            <option key={s} value={s}>
              {s === 'all' ? 'All Statuses' : s}
            </option>
          ))}
        </select>
      </div>

      {/* Search */}
      <input
        type="text"
        placeholder="Search company, role, tech..."
        value={searchQ}
        onChange={e => onSearch(e.target.value)}
        style={styles.search}
      />
    </div>
  );
}

const styles = {
  wrap: {
    display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center',
  },
  group: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  pill: {
    padding: '6px 14px', borderRadius: 20, border: '1px solid',
    fontSize: 11, cursor: 'pointer', transition: 'all 0.15s',
    letterSpacing: 0.5, fontFamily: "'JetBrains Mono', monospace",
  },
  select: {
    padding: '6px 14px', background: '#0d0f1c',
    border: '1px solid #1a1e35', borderRadius: 20,
    color: '#4a5a78', fontSize: 11, cursor: 'pointer',
    fontFamily: "'JetBrains Mono', monospace",
    outline: 'none',
  },
  search: {
    marginLeft: 'auto', padding: '7px 14px',
    background: '#0d0f1c', border: '1px solid #1a1e35',
    borderRadius: 20, color: '#c8d4f0', fontSize: 11,
    outline: 'none', minWidth: 200,
    fontFamily: "'JetBrains Mono', monospace",
  },
};
